import { TDepositCoin } from './types/deposit-request-body.interface';

export const DepositRoute = {
  DashboardDeposit: (): string => '/dashboard/balance/replenish',
  DashboardPaymentStatus: (address: string, coin: TDepositCoin): string =>
    `/invoice/wallet/status?address=${address}&coin=${coin}`,
};
